import { render, staticRenderFns } from "./pdetailTabs.vue?vue&type=template&id=8a023e96&scoped=true&"
import script from "./pdetailTabs.vue?vue&type=script&lang=js&"
export * from "./pdetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./pdetailTabs.vue?vue&type=style&index=0&id=8a023e96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a023e96",
  null
  
)

export default component.exports